import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "string-entry",
  styleUrls: ["./string-entry.component.css"],
  templateUrl: "./string-entry.component.html",
})
export class StringEntryComponent {
  @Input() public value = "";
  @Output() valueChange = new EventEmitter<string>();
  @Output() valueDeleted = new EventEmitter<string>();

  public update() {
    this.valueChange.emit(this.value);
  }

  public delete() {
    this.valueDeleted.emit(this.value);
  }
}